import React from "react";

const CSS = `
.hl-banner{
  --hl-yellow:#F7C948;--hl-pink:#FF2BD6;--hl-bg:#111111;--hl-text:#ffffff;--hl-muted:#d4d4d8;--hl-soft:#a1a1aa;
  position:relative;display:flex;align-items:center;gap:34px;max-width:100%;margin:0 0 20px;padding:30px 40px;
  min-height:300px;background:var(--hl-bg);color:var(--hl-text);border-radius:26px;overflow:hidden;font-family:inherit;box-sizing:border-box;
}
.hl-banner *{box-sizing:border-box}
.hl-banner::before{content:"";position:absolute;inset:0;background-image:radial-gradient(rgba(255,255,255,.08) 1.5px,transparent 1.6px);background-size:22px 22px;pointer-events:none;}
.hl-banner > *{position:relative}
.hl-banner__text{flex:1;min-width:0}
.hl-banner__top{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
.hl-banner__icon{width:48px;height:48px;border-radius:12px;display:block}
.hl-banner__pill{background:var(--hl-pink);color:#fff;font-weight:800;font-size:12px;letter-spacing:.08em;text-transform:uppercase;padding:7px 12px;border-radius:999px;line-height:1;}
.hl-banner__title{font-size:34px;line-height:1.05;letter-spacing:-.03em;font-weight:800;margin:16px 0 8px;color:var(--hl-text);}
.hl-banner__title em{font-style:normal;color:var(--hl-yellow)}
.hl-banner__desc{font-size:16px;line-height:1.45;color:var(--hl-muted);margin:0 0 18px;max-width:560px;}
.hl-banner__cta{display:flex;align-items:center;gap:18px;flex-wrap:wrap}
.hl-banner__btn{display:inline-block;background:var(--hl-yellow);color:#111;font-weight:800;font-size:16px;padding:13px 22px;border-radius:13px;text-decoration:none;transition:transform .15s ease, box-shadow .15s ease;}
.hl-banner__btn:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(247,201,72,.35)}
.hl-banner__link{color:#fff;font-weight:700;font-size:14px;text-decoration:underline;text-underline-offset:4px;}
.hl-banner__link:hover{color:var(--hl-yellow)}
.hl-banner__sig{font-size:12px;color:var(--hl-soft);margin:14px 0 0}
.hl-banner__visual{position:relative;width:560px;height:250px;flex:none}
.hl-banner__browser{position:absolute;left:0;top:10px;width:430px;height:240px;border-radius:12px;overflow:hidden;background:#27272a;box-shadow:0 20px 40px rgba(0,0,0,.5);}
.hl-banner__bar{height:24px;display:flex;align-items:center;gap:6px;padding:0 10px}
.hl-banner__bar i{width:8px;height:8px;border-radius:50%;background:#52525b;display:block}
.hl-banner__bar span{margin-left:10px;font-size:10px;color:var(--hl-soft);background:#3f3f46;border-radius:6px;padding:2px 10px}
.hl-banner__browser img{display:block;width:100%;height:216px;object-fit:cover;object-position:left top;background:#fff}
.hl-banner__phone{position:absolute;right:0;top:-10px;width:140px;height:270px;border-radius:24px;border:6px solid #2a2a2e;overflow:hidden;background:#fff;box-shadow:0 20px 40px rgba(0,0,0,.65);}
.hl-banner__phone img{display:block;width:100%;height:100%;object-fit:cover;object-position:top center}
.hl-banner__price{position:absolute;right:118px;bottom:6px;z-index:3;background:var(--hl-pink);color:#fff;font-weight:800;font-size:16px;padding:8px 12px;border-radius:12px;transform:rotate(-4deg);box-shadow:0 8px 20px rgba(0,0,0,.45);white-space:nowrap;}
@media (max-width:1100px){
  .hl-banner__visual{width:440px;height:220px}.hl-banner__browser{width:340px;height:200px}.hl-banner__browser img{height:176px}
  .hl-banner__phone{width:120px;height:232px}.hl-banner__price{right:96px}.hl-banner__title{font-size:30px}
}
@media (max-width:760px){
  .hl-banner{flex-direction:column;align-items:stretch;gap:24px;padding:26px 20px;margin:0 0 20px;min-height:0}
  .hl-banner__title{font-size:26px}.hl-banner__desc{font-size:15px}
  .hl-banner__cta{flex-direction:column;align-items:stretch;gap:12px}
  .hl-banner__btn{text-align:center}.hl-banner__link{text-align:center}.hl-banner__sig{text-align:center}
  .hl-banner__visual{width:100%;max-width:340px;height:200px;margin:0 auto}
  .hl-banner__browser{width:76%;height:180px;top:10px}.hl-banner__browser img{height:156px}
  .hl-banner__phone{width:96px;height:190px;top:0}.hl-banner__price{right:70px;bottom:0;font-size:14px}
}
@media (prefers-reduced-motion:reduce){.hl-banner__btn{transition:none}.hl-banner__btn:hover{transform:none}}
`;

export default function HostlandBanner() {
  return (
    <>
      <style>{CSS}</style>
      <section className="hl-banner" aria-labelledby="hl-banner-title" data-testid="hostland-banner">
        <div className="hl-banner__text">
          <div className="hl-banner__top">
            <img className="hl-banner__icon" src="/img/hostland-icon.png" width="48" height="48" alt="Logo Hostland" />
            <span className="hl-banner__pill">Vieni da Noi ora è Hostland</span>
          </div>

          <h2 id="hl-banner-title" className="hl-banner__title">
            Il tuo sito, il tuo Welcomebook, <em>il tuo mondo.</em>
          </h2>

          <p className="hl-banner__desc">
            Il Welcomebook digitale per i tuoi ospiti e il sito della tua struttura per ricevere prenotazioni dirette, senza commissioni.
          </p>

          <div className="hl-banner__cta">
            <a className="hl-banner__btn" href="https://hostland.vitadahost.it/" target="_blank" rel="noopener" data-testid="hostland-banner-cta">Prova gratis 30 giorni</a>
            <a className="hl-banner__link" href="https://hostland.vitadahost.it/vienidanoi" target="_blank" rel="noopener" data-testid="hostland-banner-vienidanoi">Arrivi da Vieni da Noi? Scopri l'offerta</a>
          </div>

          <p className="hl-banner__sig">Hostland, un prodotto di Vita da Host</p>
        </div>

        <div className="hl-banner__visual">
          <div className="hl-banner__browser">
            <div className="hl-banner__bar" aria-hidden="true"><i></i><i></i><i></i><span>hostland.vitadahost.it</span></div>
            <img src="/img/hostland-sito.webp" width="430" height="216" loading="lazy" decoding="async" alt="Hostland, prenota diretto senza commissioni" />
          </div>
          <div className="hl-banner__phone">
            <img src="/img/hostland-welcomebook.webp" width="128" height="258" loading="lazy" decoding="async" alt="Welcomebook digitale di Hostland per gli ospiti" />
          </div>
          <span className="hl-banner__price">59,90 € / anno</span>
        </div>
      </section>
    </>
  );
}
